import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useQuery } from '@tanstack/react-query';
import { JSONContent } from '@tiptap/core';
import { upperFirst } from 'lodash';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { useProductCenterApi } from 'api';
import { releaseNoteContentQuery } from 'api/queries';
import RichText from 'library/components/controls/richtexteditor/RichText';

type ReleaseNoteDevAccordionContentProps = {
	id: number;
};

export const ReleaseNoteDevAccordionContent = ({
	id,
}: ReleaseNoteDevAccordionContentProps) => {
	const { t } = useTranslation(['releaseNotes']);
	const { api } = useProductCenterApi();
	const { data } = useQuery(releaseNoteContentQuery(api, id));
	const { internalContent, externalContent } = data ?? {};

	const parsedInternalContent = useMemo(
		() =>
			internalContent ? (JSON.parse(internalContent) as JSONContent) : '',
		[internalContent]
	);

	const parsedExternalContent = useMemo(
		() =>
			externalContent ? (JSON.parse(externalContent) as JSONContent) : '',
		[externalContent]
	);

	return (
		<Stack spacing={4}>
			<Box>
				<Typography variant="h3" marginBottom={1}>
					{upperFirst(t('releaseNotes:internal'))}
				</Typography>
				<RichText content={parsedInternalContent} />
			</Box>
			<Box>
				<Typography variant="h3" marginBottom={1}>
					{upperFirst(t('releaseNotes:external'))}
				</Typography>
				<RichText content={parsedExternalContent} />
			</Box>
		</Stack>
	);
};
